import { requestJson } from '../utils/http/request'
import { stringify } from '../utils/object/stringify'
import type { LoggerCollector } from './LoggerCollector'

export type SplunkCollectorArgs = {
  endpoint: string
  token: string
  path?: string
  sourcetype?: string
  host?: string
}

type SplunkSeverity = {
  level: 'Critical' | 'Important' | 'Debug'
  type: 'Error' | 'Warn' | 'Info'
}

const LOG_LABEL_TO_SPLUNK_SEVERITY: Record<number, SplunkSeverity> = {
  10: { level: 'Debug', type: 'Info' },
  20: { level: 'Debug', type: 'Info' },
  30: { level: 'Important', type: 'Info' },
  40: { level: 'Important', type: 'Warn' },
  50: { level: 'Important', type: 'Error' },
  60: { level: 'Critical', type: 'Error' },
}

export const SplunkCollector = {
  create({
    endpoint,
    token,
    path = '/services/collector/event',
    sourcetype = 'log',
    host = '-',
  }: SplunkCollectorArgs) {
    const collector: LoggerCollector = {
      async send(logs, { signal }) {
        const formattedEvents = logs.map((log) => {
          const { level, time, ...event } = log

          return {
            sourcetype,
            host,
            time,
            event: {
              ...LOG_LABEL_TO_SPLUNK_SEVERITY[level],
              ...event,
            },
          }
        })

        const body = formattedEvents.map((event) => stringify(event)).join('\n')

        await requestJson(`${endpoint}${path}`, {
          signal,
          method: 'POST',
          body,
          credentials: 'omit',
          headers: {
            Authorization: `Splunk ${token}`,
          },
        })
      },
    }

    return collector
  },
}
